import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={800}
    height={800}
    viewBox="0 0 24 24"
    {...props}
    fill="none"
    stroke="none">
    <Path
      stroke={props.fill || 'rgb(236, 237, 255)'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 10h8m-8 4h8m5.004-2a9 9 0 0 1-9 9h-9s1.56-3.744.936-5a9 9 0 1 1 17.064-4Z"
    />
  </Svg>
);
export default SvgComponent;
